export function addCommaSeparator(n: number): string {
  if (typeof n !== 'number') {
    return '';
  }
  return Intl.NumberFormat('en', { notation: 'standard' }).format(n);
}

export function roundToHundred(n: number): number {
  return Math.round(n / 100) * 100;
}

export function formatNumber(n: number): string {
  if (n >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(1)}M`;
  }
  if (n >= 1_000) {
    return `${Math.floor(n / 1_000)},${String(n % 1_000).padStart(3, '0')}`;
  }
  return String(n);
}
